import {compress, canvastoFile} from 'image-conversion';

export default {
  install: function(Vue,) {
    Object.defineProperty(Vue.prototype, '$compress', { value: compress });
    Object.defineProperty(Vue.prototype, '$canvastoFile', { value: canvastoFile });
    // Object.defineProperty(Vue.prototype, name, { value: stringify });
  }
}
